import React from 'react';
import styles from './AdminProductList.module.scss';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { userList } from '../../../redux/actions/user/userList';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { postList } from '../../../redux/actions/app/postList';
import Player from 'react-player';
import { productList } from '../../../redux/actions/app/productList';

const AdminProductList = () => {
  const columns = [
    {
      label: 'Фото',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100px', height: '100px' }}>
          <Box component={'img'} src={val?.image} sx={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '6px', margin: '0 auto' }}></Box>
        </Box>
      ),
    },
    {
      label: 'Название',
      onTransform: (val) => val?.title,
    },
    {
      label: 'Цена',
      onTransform: (val) => val?.cost + '₽',
    },
    {
      label: 'Описание',
      onTransform: (val) => <Box sx={{ textAlign: 'left', maxWidth: '200px', width: '200px', whiteSpace: 'normal' }}>{val?.description}</Box>,
    },
    {
      label: 'Автор',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: 'auto' }}>
          <Box component={'img'} src={val?.creator?.avatar} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
          <Box>{`${val?.creator?.lastName} ${val?.creator?.firstName}`}</Box>
        </Box>
      ),
    },

    {
      label: 'Дата создания',
      onTransform: (val) => (val?.createdAt ? dayjs(val?.createdAt).format('DD.MM.YYYY HH:mm') : '-'),
    },
  ];
  return (
    <div>
      <AdminTableList title={'Товары'} sliceName={'app'} actionName={'productList'} fetch={productList} pathEdit="/admin/product/edit" columns={columns} textEmpty={'Товаров нет'} />
    </div>
  );
};

export default AdminProductList;
